import { HTMLProps, useContext } from 'react';
import { IconElements } from '../../../../config/icons';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';

export const PlusAndMinusPensionAgeButton: React.FC<{ isPartnerPension?: boolean } & HTMLProps<HTMLDivElement>> = ({
    isPartnerPension = false,
    className,
}) => {
    const {
        parameters: { personalInfo },
        actions,
    } = useContext(PensionContext);
    return (
        <div className="flex flex-col items-start">
            <div className="mb-6">{isPartnerPension ? 'Pensioenleeftijd partner' : 'Uw pensioenleeftijd'}</div>
            <div className="flex flex-row justify-start items-center">
                <div
                    className={`${className} rounded-full mr-4 text-bnd-green font-bold text-4xl border bg-bnd-white-1 flex justify-center items-center cursor-pointer py-5 px-3`}
                    onClick={() =>
                        isPartnerPension
                            ? actions.setParameters({
                                  personalInfo: { partner: { pensionAge: personalInfo.partner?.pensionAge! - 1 } },
                              })
                            : actions.setParameters({
                                  personalInfo: { self: { pensionAge: personalInfo.self?.pensionAge! - 1 } },
                              })
                    }
                >
                    <IconElements.Minus />
                </div>
                <span className="mr-4 text-xl text-bnd-green">
                    {isPartnerPension ? personalInfo.partner?.pensionAge : personalInfo.self?.pensionAge}
                </span>
                <div
                    className={`${className} rounded-full text-bnd-green font-bold text-4xl border bg-bnd-white-1 flex justify-center items-center cursor-pointer py-3
         px-3`}
                    onClick={() =>
                        isPartnerPension
                            ? actions.setParameters({
                                  personalInfo: { partner: { pensionAge: personalInfo.partner?.pensionAge! + 1 } },
                              })
                            : actions.setParameters({
                                  personalInfo: { self: { pensionAge: personalInfo.self?.pensionAge! + 1 } },
                              })
                    }
                >
                    <IconElements.Plus />
                </div>
            </div>
        </div>
    );
};
